export default {
    DRAFT: 0,
    PUBLISHED: 1,
}